import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._outsideClick = this._handleOutsideClick.bind(this);
    this._keydown = this._handleKeydown.bind(this);
  }

  toggle(event) {
    event.stopPropagation();

    if (this.menuTarget.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.menuTarget.hidden = false;
    this._button.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() => {
      document.addEventListener("click", this._outsideClick);
      document.addEventListener("keydown", this._keydown);
    });
  }

  close() {
    this.menuTarget.hidden = true;
    this._button.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this._outsideClick);
    document.removeEventListener("keydown", this._keydown);
  }

  get _button() {
    return this.element.querySelector("[aria-expanded]");
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  disconnect() {
    document.removeEventListener("click", this._outsideClick);
    document.removeEventListener("keydown", this._keydown);
  }
}
